/**
 * Request Payment Use Case
 * 결제 요청 유스케이스
 */

import type { PaymentRepository } from '../../repositories/PaymentRepository';
import type { PaymentRequest } from '../../models/payments/Payment';

/**
 * 결제 요청 유스케이스
 */
export class RequestPaymentUseCase {
  constructor(private readonly paymentRepository: PaymentRepository) {}

  /**
   * 결제 요청 실행
   * @param request 결제 요청 데이터
   */
  async execute(request: PaymentRequest): Promise<void> {
    // 결제 요청 데이터 검증
    this.validatePaymentRequest(request);

    // 결제 레포지토리를 통해 결제 요청
    await this.paymentRepository.requestPayment(request);
  }

  /**
   * 결제 요청 데이터 검증
   */
  private validatePaymentRequest(request: PaymentRequest): void {
    if (!request.mid) {
      throw new Error('상점아이디(MID)는 필수입니다.');
    }
    if (!request.oid) {
      throw new Error('주문번호(OID)는 필수입니다.');
    }
    if (!request.price || request.price <= 0) {
      throw new Error('유효한 결제금액을 입력해주세요.');
    }
    if (!request.goodname) {
      throw new Error('상품명은 필수입니다.');
    }
    if (!request.buyername) {
      throw new Error('구매자명은 필수입니다.');
    }
    if (!request.buyertel) {
      throw new Error('구매자 전화번호는 필수입니다.');
    }
    if (!request.buyeremail) {
      throw new Error('구매자 이메일은 필수입니다.');
    }
  }
}
